import { Component } from '@angular/core';

@Component({
    selector: 'app-pretty-card',
    templateUrl: './pretty-card.component.html',
    standalone: false
})
export class PrettyCardComponent {

}
